import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Grid,
  Icon,
  Pagination,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import GuideStyles from "assets/js/guide";
import PhotoCameraIcon from "@mui/icons-material/PhotoCamera";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore";
import SearchIcon from "@mui/icons-material/Search";
import DeleteIcon from "@mui/icons-material/Delete";
import IconButton from "@mui/material/IconButton";

import "codemirror/lib/codemirror.css";
import "codemirror/theme/dracula.css";
import "codemirror/theme/material.css";

import "codemirror/theme/mdn-like.css";
import "codemirror/theme/the-matrix.css";
import "codemirror/theme/night.css";

import "codemirror/mode/xml/xml";
import "codemirror/mode/javascript/javascript";
import "codemirror/mode/css/css";

import "codemirror/addon/edit/closebrackets";
import "codemirror/addon/edit/closetag";
import { Controlled as ControlledEditor } from "react-codemirror2-react-17";

export default function GuideButton() {
  /* Accordion */
  const [codemirror, setCodemirror] = useState();
  const handleCodemirror = panel => (event, newcodemirror) => {
    setCodemirror(newcodemirror ? panel : false);
  };

  return (
    <>
      <GuideStyles />
      <main id="main" className="container">
        <Box className="box-type-2">
          <div className="h-group">
            <h2 className="guide-h2">Button</h2>
          </div>

          <h3 className="guide-h3">Basic</h3>
          <div className="btn-wrap">
            <div className="btn-area">
              <Button variant="contained" color="primary">
                primary
              </Button>
              <Button variant="contained" color="primary" disabled>
                disabled
              </Button>
              {/* <Button variant="outlined" color="primary" disabled>
                disabled
              </Button> */}
            </div>

            <Accordion
              codemirror={codemirror === "Basic"}
              onChange={handleCodemirror("Basic")}
              className="accordion-codemirror"
            >
              <AccordionSummary>
                <p>코드보기</p>
              </AccordionSummary>
              <AccordionDetails>
                <ControlledEditor
                  value={`<div className="btn-area">
  <Button variant="contained" color="primary">
    primary
  </Button>

  <Button variant="contained" color="primary" disabled>
    disabled
  </Button>
</div>
              `}
                  className="code-mirror-wrapper"
                  options={{
                    lineWrapping: true,
                    lint: true,
                    mode: "xml",
                    theme: "material",
                    lineNumbers: true,
                  }}
                />
              </AccordionDetails>
            </Accordion>
          </div>

          <hr className="guide-hr" />

          <h3 className="guide-h3">
            General (글자수에 따라 크기 유동적으로 변함.)
          </h3>
          <div>
            <Button size="small" color="primary" variant="outlined">
              size='sm'
            </Button>
            <Button size="small" color="primary" variant="contained">
              size='sm'
            </Button>
            <Button color="primary" variant="outlined">
              size='md'
            </Button>
            <Button color="primary" variant="contained">
              size='md'
            </Button>
            <Button color="secondary" variant="outlined">
              size='md'
            </Button>
            <Button color="secondary" variant="contained">
              size='md'
            </Button>

            <Accordion
              codemirror={codemirror === "General"}
              onChange={handleCodemirror("General")}
              className="accordion-codemirror"
            >
              <AccordionSummary>
                <p>코드보기</p>
              </AccordionSummary>
              <AccordionDetails>
                <ControlledEditor
                  value={`<Button size="small" color="primary" variant="outlined">
  size='sm'
</Button>

<Button size="small" color="primary" variant="contained">
  size='sm'
</Button>

<Button color="primary" variant="outlined">
  size='md'
</Button>

<Button color="primary" variant="contained">
  size='md'
</Button>

<Button color="secondary" variant="outlined">
  size='md'
</Button>

<Button color="secondary" variant="contained">
  size='md'
</Button>
              `}
                  className="code-mirror-wrapper"
                  options={{
                    lineWrapping: true,
                    lint: true,
                    mode: "xml",
                    theme: "material",
                    lineNumbers: true,
                  }}
                />
              </AccordionDetails>
            </Accordion>
          </div>

          <hr className="guide-hr" />

          <h3 className="guide-h3">Fixed</h3>
          <div>
            <Button className="btn-fixed" variant="contained" color="primary">
              Apply
            </Button>
            <Button className="btn-fixed" color="secondary" variant="contained">
              Complete
            </Button>
            <Button className="btn-fixed" color="primary" variant="outlined">
              Prev
            </Button>

            <Accordion
              codemirror={codemirror === "Fixed"}
              onChange={handleCodemirror("Fixed")}
              className="accordion-codemirror"
            >
              <AccordionSummary>
                <p>코드보기</p>
              </AccordionSummary>
              <AccordionDetails>
                <ControlledEditor
                  value={`<Button className="btn-fixed" 
variant="contained" 
color="primary">
  Apply
</Button>

<Button className="btn-fixed" 
color="secondary" 
variant="contained">
  Complete
</Button>

<Button className="btn-fixed" 
color="primary" 
variant="outlined">
  Prev
</Button>
              `}
                  className="code-mirror-wrapper"
                  options={{
                    lineWrapping: true,
                    lint: true,
                    mode: "xml",
                    theme: "material",
                    lineNumbers: true,
                  }}
                />
              </AccordionDetails>
            </Accordion>
          </div>

          <hr className="guide-hr" />

          <h3 className="guide-h3">Route</h3>
          <div>
            <Link to="/" className="btn-link">
              Route Btn
            </Link>
            <Link to="/" className="btn-link underline">
              Route Btn
            </Link>
            <Link to="/" className="btn-link color-info">
              Route Btn
            </Link>

            <Accordion
              codemirror={codemirror === "Route"}
              onChange={handleCodemirror("Route")}
              className="accordion-codemirror"
            >
              <AccordionSummary>
                <p>코드보기</p>
              </AccordionSummary>
              <AccordionDetails>
                <ControlledEditor
                  value={`<Link to="/" className="btn-link">
  Route Btn
</Link>

<Link to="/" className="btn-link underline">
  Route Btn
</Link>

<Link to="/" className="btn-link color-info">
  Route Btn
</Link>
              `}
                  className="code-mirror-wrapper"
                  options={{
                    lineWrapping: true,
                    lint: true,
                    mode: "xml",
                    theme: "material",
                    lineNumbers: true,
                  }}
                />
              </AccordionDetails>
            </Accordion>
          </div>

          <hr className="guide-hr" />

          <h3 className="guide-h3">Icon</h3>
          <div>
            <Button
              variant="outlined"
              color="primary"
              size="small"
              // startIcon={
              //   <Icon>
              //     <img
              //       src={`${process.env.PUBLIC_URL}/images/icon/icon-camera.svg`}
              //       alt="camera"
              //     />
              //   </Icon>
              // }
            >
              <PhotoCameraIcon />
              Selected Image
            </Button>
            <Button
              variant="outlined"
              // startIcon={
              //   <Icon>
              //     <img
              //       src={`${
              //         process.env.PUBLIC_URL
              //       }/images/icon/icon-download-disabled.svg`}
              //       alt="camera"
              //     />
              //   </Icon>
              // }
            >
              <FileDownloadIcon />
              Video
            </Button>
            <Button
              variant="contained"
              // startIcon={
              // <Icon>
              //   <img
              //     src={`${
              //       process.env.PUBLIC_URL
              //     }/images/icon/icon-download-white.svg`}
              //     alt="camera"
              //   />
              // </Icon>
              // }
            >
              <FileDownloadIcon />
              PDF
            </Button>
            <IconButton aria-label="search">
              <SearchIcon />
            </IconButton>
            <IconButton aria-label="delete">
              <DeleteIcon />
            </IconButton>

            <Accordion
              codemirror={codemirror === "Icon"}
              onChange={handleCodemirror("Icon")}
              className="accordion-codemirror"
            >
              <AccordionSummary>
                <p>코드보기</p>
              </AccordionSummary>
              <AccordionDetails>
                <ControlledEditor
                  value={`<Button
  variant="outlined"
  color="primary"
  size="small"
  startIcon={
    <Icon>
      <img
        src={${process.env.PUBLIC_URL}/images/icon/icon-camera.svg}
        alt="camera"
      />
    </Icon>
  }
>
  Selected Image
</Button>

<Button
  variant="outlined"
  startIcon={
    <Icon>
      <img
        src={${process.env.PUBLIC_URL}/images/icon/icon-download-disabled.svg}
        alt="camera"
      />
    </Icon>
  }
>
  Video
</Button>

<Button
  variant="contained"
  startIcon={
    <Icon>
      <img
        src={${process.env.PUBLIC_URL}/images/icon/icon-download-white.svg}
        alt="camera"
      />
    </Icon>
  }
>
  PDF
</Button>

<IconButton aria-label="search">
  <SearchIcon />
</IconButton>

<IconButton aria-label="delete">
  <DeleteIcon />
</IconButton>
                  `}
                  className="code-mirror-wrapper"
                  options={{
                    lineWrapping: true,
                    lint: true,
                    mode: "xml",
                    theme: "material",
                    lineNumbers: true,
                  }}
                />
              </AccordionDetails>
            </Accordion>
          </div>

          <hr className="guide-hr" />

          <h3 className="guide-h3">Rounded</h3>
          <div>
            <Button
              fullWidth
              className="btn-rounded"
              color="primary"
              variant="contained"
              size="large"
            >
              size='lg' Rounded Pill
            </Button>
            <br />
            <br />
            <Button
              variant="outlined"
              color="primary"
              className="btn-rounded end-icon"
              size="small"
              endIcon={<i className="ico-go" />}
            >
              전단 바로가기
            </Button>
            <br />
            <br />
            <Link
              to={"/"}
              className="link-outlined link-primary link-size-small btn-rounded end-icon"
            >
              전단 바로가기
              <i className="ico-go" />
            </Link>

            <Accordion
              codemirror={codemirror === "Rounded"}
              onChange={handleCodemirror("Rounded")}
              className="accordion-codemirror"
            >
              <AccordionSummary>
                <p>코드보기</p>
              </AccordionSummary>
              <AccordionDetails>
                <ControlledEditor
                  value={`<Button
  fullWidth
  className="btn-rounded"
  color="primary"
  variant="contained"
  size="large"
>
  size='lg' Rounded Pill
</Button>

<Button
  variant="outlined"
  color="primary"
  className="btn-rounded end-icon"
  size="small"
  endIcon={<i className="ico-go" />}
>
  전단 바로가기
</Button>

<Link
  to={"/"}
  className="link-outlined link-primary link-size-small btn-rounded end-icon"
>
  전단 바로가기
  <i className="ico-go" />
</Link>
              `}
                  className="code-mirror-wrapper"
                  options={{
                    lineWrapping: true,
                    lint: true,
                    mode: "xml",
                    theme: "material",
                    lineNumbers: true,
                  }}
                />
              </AccordionDetails>
            </Accordion>
          </div>

          <hr className="guide-hr" />

          <h3 className="guide-h3">Text</h3>
          <div>
            <Button color="primary" startIcon={<NavigateBeforeIcon />}>
              PREV
            </Button>
            <Button color="primary" endIcon={<NavigateNextIcon />}>
              NEXT
            </Button>
            <Button color="primary" startIcon={<NavigateBeforeIcon />} disabled>
              PREV
            </Button>
            <Button color="primary" endIcon={<NavigateNextIcon />} disabled>
              NEXT
            </Button>

            <Accordion
              codemirror={codemirror === "Text"}
              onChange={handleCodemirror("Text")}
              className="accordion-codemirror"
            >
              <AccordionSummary>
                <p>코드보기</p>
              </AccordionSummary>
              <AccordionDetails>
                <ControlledEditor
                  value={`<Button color="primary" startIcon={<NavigateBeforeIcon />}>
  PREV
</Button>

<Button color="primary" endIcon={<NavigateNextIcon />}>
  NEXT
</Button>

<Button color="primary" startIcon={<NavigateBeforeIcon />} disabled>
  PREV
</Button>

<Button color="primary" endIcon={<NavigateNextIcon />} disabled>
  NEXT
</Button>
              `}
                  className="code-mirror-wrapper"
                  options={{
                    lineWrapping: true,
                    lint: true,
                    mode: "xml",
                    theme: "material",
                    lineNumbers: true,
                  }}
                />
              </AccordionDetails>
            </Accordion>
          </div>

          <hr className="guide-hr" />

          <h3 className="guide-h3">Pagination</h3>
          <Box className="bottom-area">
            <Pagination count={10} />
            <Grid container justifyContent="end">
              <Grid item>
                <Button color="primary" variant="contained">
                  등록
                </Button>
              </Grid>
            </Grid>
          </Box>
          <br />
          <br />

          <Box className="bottom-area">
            <Pagination count={10} />
            <Grid container justifyContent="space-between">
              <Grid item>
                <Button color="primary" variant="contained">
                  목록
                </Button>
              </Grid>
              <Grid item>
                <Button color="primary" variant="contained">
                  등록
                </Button>
              </Grid>
            </Grid>
          </Box>

          <Accordion
            codemirror={codemirror === "Pagination"}
            onChange={handleCodemirror("Pagination")}
            className="accordion-codemirror"
          >
            <AccordionSummary>
              <p>코드보기</p>
            </AccordionSummary>
            <AccordionDetails>
              <ControlledEditor
                value={`<Box className="bottom-area">
  <Pagination count={10} />
  <Grid container justifyContent="end">
    <Grid item>
      <Button color="primary" variant="contained">
        등록
      </Button>
    </Grid>
  </Grid>
</Box>

<Box className="bottom-area">
  <Pagination count={10} />
  <Grid container justifyContent="space-between">
    <Grid item>
      <Button color="primary" variant="contained">
        목록
      </Button>
    </Grid>
    <Grid item>
      <Button color="primary" variant="contained">
        등록
      </Button>
    </Grid>
  </Grid>
</Box>
              `}
                className="code-mirror-wrapper"
                options={{
                  lineWrapping: true,
                  lint: true,
                  mode: "xml",
                  theme: "material",
                  lineNumbers: true,
                }}
              />
            </AccordionDetails>
          </Accordion>

          <hr className="guide-hr" />

          <h3 className="guide-h3">Center 2개</h3>
          <Box className="bottom-area">
            <Grid container justifyContent="center" spacing={2}>
              <Grid item>
                <Button className="btn-cancel" variant="contained">
                  취소
                </Button>
              </Grid>
              <Grid item>
                <Button color="primary" variant="contained">
                  등록
                </Button>
              </Grid>
            </Grid>
          </Box>

          <Accordion
            codemirror={codemirror === "Center2ea"}
            onChange={handleCodemirror("Center2ea")}
            className="accordion-codemirror"
          >
            <AccordionSummary>
              <p>코드보기</p>
            </AccordionSummary>
            <AccordionDetails>
              <ControlledEditor
                value={`<Box className="bottom-area">
  <Grid container justifyContent="center" spacing={2}>
    <Grid item>
      <Button className="btn-cancel" variant="contained">
        취소
      </Button>
    </Grid>
    <Grid item>
      <Button color="primary" variant="contained">
        등록
      </Button>
    </Grid>
  </Grid>
</Box>
              `}
                className="code-mirror-wrapper"
                options={{
                  lineWrapping: true,
                  lint: true,
                  mode: "xml",
                  theme: "material",
                  lineNumbers: true,
                }}
              />
            </AccordionDetails>
          </Accordion>
        </Box>
      </main>
    </>
  );
}
